import React from 'react'

const Termsconditions = () => {
    return (
        <div>
            <strong>Terms and Conditions</strong>
            <ul>
                <li><strong>Effective Date:</strong> 2025</li>
                <li><strong>Operated by:</strong> Fyjix IT Solutions (India)</li>
                <li>
                    These Terms and Conditions govern your access to and use of the Fyjix text-to-speech service (the "Service"). By creating an account, accessing the platform, or using any feature of the Service, you agree to be bound by these Terms.
                </li>

                <strong>1. Definitions</strong>
                <ul>
                    <li><strong>Service</strong> refers to the Fyjix text-to-speech (TTS) platform and its features.</li>
                    <li><strong>User</strong>, <strong>you</strong>, or <strong>your</strong> refers to any individual or entity using the Service.</li>
                    <li><strong>We</strong>, <strong>us</strong>, or <strong>our</strong> refers to Fyjix IT Solutions.</li>
                    <li><strong>Generated Audio</strong> means the audio file created using your text input.</li>
                    <li><strong>Account</strong> means a registered user profile created with a verified email.</li>
                </ul>

                <strong>2. Eligibility</strong>
                <ul>
                    <li>You must register with a valid verified email to use paid features.</li>
                    <li>Users under 18 should use the Service with guardian consent.</li>
                </ul>

                <strong>3. User Accounts</strong>
                <ul>
                    <li>Registration with a verified email is required.</li>
                    <li>We store:</li>
                    <li>Email (mandatory)</li>
                    <li>Name and contact number (optional)</li>
                    <li>You are responsible for your login credentials and all activity under your account.</li>
                </ul>

                <strong>4. Services Provided</strong>
                <ul>
                    <li>Fyjix provides online text-to-speech generation in multiple languages and accents.</li>
                    <li>A demo feature allows limited free use before purchasing character packs.</li>
                </ul>

                <strong>5. Payments, Pricing, and Refunds</strong>
                <ul>
                    <li>Payments are processed through the TJSB Bank payment gateway.</li>
                    <li>All purchases are non-refundable.</li>
                    <li>Characters never expire.</li>
                    <li>Refunds may be issued only if a verified system error prevented service delivery.</li>
                    <li>Price changes may occur and continued use implies acceptance.</li>
                </ul>

                <strong>6. Licensing and Ownership of Generated Audio</strong>
                <ul>
                    <li>You retain full commercial ownership of all Generated Audio.</li>
                    <li>We do not claim rights over your audio.</li>
                    <li>You are responsible for ensuring your text and use of the audio comply with applicable laws.</li>
                </ul>

                <strong>7. User Content and Data Handling</strong>
                <ul>
                    <li>
                        <strong>7.1 Text Input, Logs, and Stored Data</strong>
                        <ul>
                            <li>To operate the Service, maintain security, and prevent abuse, we store the following:</li>
                            <li>IP addresses</li>
                            <li>User actions performed on the platform</li>
                            <li>Text input submitted for generating audio</li>
                            <li>Character usage logs</li>
                            <li>Character count history</li>
                            <li>Email (mandatory)</li>
                            <li>Name and contact number (optional)</li>
                        </ul>
                    </li>

                    <li>
                        <strong>7.2 Audio Storage</strong>
                        <ul>
                            <li>We do not store any Generated Audio.</li>
                            <li>Audio is processed and delivered but not saved, retained, or archived by Fyjix.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>7.3 Payment Information</strong>
                        <ul>
                            <li>We do not collect or store payment card details.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>7.4 Privacy</strong>
                        <ul>
                            <li>Data is handled according to our Privacy Policy.</li>
                        </ul>
                    </li>
                </ul>

                <strong>8. Acceptable Use Policy</strong>
                <ul>
                    <li>You must not use the Service to:</li>
                    <li>Create deepfake voices or misleading impersonations.</li>
                    <li>Produce or distribute political content.</li>
                    <li>Generate hate speech, harassment, threats, or abusive material.</li>
                    <li>Conduct illegal, fraudulent, or harmful activities.</li>
                    <li>Violate copyright or third-party intellectual property rights.</li>
                    <li>Reverse-engineer or misuse the Service.</li>
                    <li>Violations may lead to account suspension or termination without refund.</li>
                </ul>

                <strong>9. Intellectual Property</strong>
                <ul>
                    <li>All software, system design, branding, and platform features belong to Fyjix IT Solutions.</li>
                    <li>Users may not exploit or reproduce the platform’s underlying intellectual property.</li>
                    <li>Generated Audio remains your property.</li>
                </ul>

                <strong>10. Service Availability & Changes</strong>
                <ul>
                    <li>We aim for high uptime but do not guarantee uninterrupted access.</li>
                    <li>The Service may be modified or discontinued at any time.</li>
                </ul>

                <strong>11. Disclaimer of Warranties</strong>
                <ul>
                    <li>The Service is provided "as-is" and "as-available".</li>
                    <li>We do not guarantee error-free operation or specific performance outcomes.</li>
                </ul>

                <strong>12. Limitation of Liability</strong>
                <ul>
                    <li>To the fullest extent permitted by law:</li>
                    <li>Fyjix is not liable for indirect or consequential damages.</li>
                    <li>Total liability is limited to the amount paid in the previous 30 days.</li>
                    <li>No liability applies for misuse or violations of these Terms.</li>
                </ul>

                <strong>13. Suspension or Termination</strong>
                <ul>
                    <li>Accounts may be suspended or terminated for violations of the Terms.</li>
                    <li>Remaining characters may be forfeited without refund.</li>
                </ul>

                <strong>14. Third-Party Links</strong>
                <ul>
                    <li>We are not responsible for third-party sites linked through the platform.</li>
                </ul>

                <strong>15. Governing Law</strong>
                <ul>
                    <li>These Terms are governed by the laws of India.</li>
                    <li>Any disputes will be resolved exclusively in Indian courts.</li>
                </ul>

                <strong>16. Contact Information</strong>
                <ul>
                    <li>For support, billing inquiries, or legal concerns, contact:</li>
                    <li>Email: info@fyjix.com</li>
                    <li>Company: Fyjix IT Solutions</li>
                    <li>Country: India</li>
                </ul>
            </ul>
        </div>
    )
}

export default Termsconditions